import * as CoreFns from './utilities/CoreFns';
import * as ResponsiveFns from './utilities/ResponsiveFns';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as FormulaFunctions from './utilities/FormulaFunctions';
import * as TypeEvaluation from './TypeEvaluation';
// import { watchContractEvent } from '@wagmi/core'

function itemsToCheck(listOfHeaders, possibSimpl, doEvalG){
  for (var i = 0; i < listOfHeaders.length; i++){
    var v1 = doEvalG(possibSimpl[listOfHeaders[i]], {t:'NoNeedCosOnlyFormulasWillScrewThisUp'}, [{t:'RequireChecked', v:1}]);
    if (v1 === undefined){
      return false;
    }
  }
  return true;
}

 

export function doInteractionFn(contractEvents, setContractEvents, writeContract, chains, currentList, internalVariables, width, height, inputValues, setInputValues, ownVariables, setOwnVariables, musicStatus, setMusicStatus, alertVisibility, setAlertVisibility, urlParamsForExecution, urlHeader, init, currentPreviewFE, setPreviewFE, screenRefs, popUps, setPopUps, programSetID, setAppInfo, setChainInfo){

  function doSimplInteract(possibSimpl, entityPathIn, upwardInfoHere, depth){
    var newDepth = depth + 1;
    
    function doEvalG(v, type, additionalUpwards){
      try{
        var u = upwardInfoHere;
        if (additionalUpwards){
          u = upwardInfoHere.concat(additionalUpwards);
        }
        return FormulaFunctions.evaluateCondition(v, type, entityPathIn, currentList, internalVariables, width, height, u, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      }catch(e){
        return undefined;
      }
    }
    if (!possibSimpl || possibSimpl.t === ''){
      return
    }


    if (possibSimpl.t === 'connectWallet'){
      init();
    }else if (possibSimpl.t === 'reloadDapp'){
      setAppInfo(false);
          
      setTimeout(function(){ 
        StyleFunctions.doStartSim(currentList, setAppInfo, setOwnVariables, setMusicStatus, width, height, urlParamsForExecution, urlHeader, chains);      
      }, 1000);
    }else if (possibSimpl.t === 'changeScreen'){
      var newScreen = doEvalG(possibSimpl.v, {t:'Screen'});
      if (newScreen === currentPreviewFE){
        var pp = ['fe', newScreen, 'nv'];
        var ppString = pp.join('_');
        var navRef = screenRefs[ppString];
        if (navRef){
          navRef.current.scrollIntoView({ behavior: 'smooth' });
        }else{
          var screens = CoreFns.goDownPath(currentList, ['fe', newScreen, '_s']);
          var screenKeys = CoreFns.sortedKeyList(screens);
          if (screenKeys.length > 0){
            var pp1 = ['fe', newScreen, '_s', screenKeys[0]];
            var thisRef = screenRefs[pp1.join('_')];
            if (thisRef){
              thisRef.current.scrollIntoView({ behavior: 'smooth' }); 
            }
          }
        }
      }else if (newScreen !== '_placeholderPage'){
        setPreviewFE(newScreen);
      }
      doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
    }else if (possibSimpl.t === 'toggleMusic'){
      var newMusic = doEvalG(possibSimpl.v, {t:'Music'});
      musicStatus[newMusic] = !musicStatus[newMusic];
      setMusicStatus({...musicStatus});
      doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
    }else if (possibSimpl.t === 'alert'){

      function alertFn(nosInstances){
        if (!itemsToCheck(['msg'], possibSimpl, doEvalG)){
          if (nosInstances < 3){
            setTimeout(function(e){alertFn(nosInstances + 1)}, 500);
          }
          return;
        }
        window.alert(doEvalG(possibSimpl.msg, {t:'Text String'}));
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
      }

      alertFn(0);
    }else if (possibSimpl.t === 'openUrl'){

      function openUrlFunction(){
        if (!itemsToCheck(['url'], possibSimpl, doEvalG)){
          setTimeout(function(e){openUrlFunction()}, 500);
          return;
        }
        window.open(doEvalG(possibSimpl.url, {t:'Text String'}));
      }

      openUrlFunction();
    }else if (possibSimpl.t === 'scrollToPanel'){
      function scrollFn(){
        if (!itemsToCheck(['panel'], possibSimpl, doEvalG)){
          setTimeout(function(e){scrollFn()}, 500);
          return;
        }

        var myRef = screenRefs[doEvalG(possibSimpl.panel, {t:'nPanel'})];
        if (myRef){
          myRef.current.scrollIntoView({ behavior: 'smooth' });
          // window.scrollTo({ behavior: 'smooth', top: myRef.current.offsetTop })
        }
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
      }

      scrollFn();
    }else if (possibSimpl.t === 'scrollToTop'){

      var myRef1 = screenRefs[entityPathIn[0] + '_' + entityPathIn[1]];
      if (myRef1){
        myRef1.current.scrollIntoView({ behavior: 'smooth', top:myRef1.current.offsetTop });
        // window.scrollTo({ behavior: 'smooth', top: myRef.current.offsetTop })
      }

      doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        

    }else if (possibSimpl.t === 'copyText'){
      function copyTextFn(){
        if (!itemsToCheck(['text'], possibSimpl, doEvalG)){
          setTimeout(function(e){copyTextFn()}, 500);
          return;
        }

        navigator.clipboard.writeText(doEvalG(possibSimpl.text, {t:'Text String'}));
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
      }

      copyTextFn();


    }else if (possibSimpl.t === 'delay'){
      function delayFn(){
        if (!itemsToCheck(['amt'], possibSimpl, doEvalG)){
          setTimeout(function(e){delayFn()}, 500);
          return;
        }
        setTimeout(function(e){
          doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
        }, doEvalG(possibSimpl.amt, {t:'Decimal'}) * 1000);
      }

      delayFn();


    }else if (possibSimpl.t === 'prompt'){

      function promptFn(){
        if (!itemsToCheck(['msg', 'default'], possibSimpl, doEvalG)){
          setTimeout(function(e){promptFn()}, 500);
          return;
        }
        var p2 = window.prompt(doEvalG(possibSimpl.msg, {t:'Text String'}), doEvalG(possibSimpl.default, {t:'Text String'}));
        if (p2 === null){
          doSimplInteract(possibSimpl.If_Cancel, entityPathIn.concat(['If_Cancel']), upwardInfoHere, newDepth);
        }else{
          doSimplInteract(possibSimpl.Post_Prompt, entityPathIn.concat(['Post_Prompt']), upwardInfoHere.concat([{v:p2, t:'Post_Prompt_'+depth}]), newDepth);

        }        
      }
      promptFn();
    }else if (possibSimpl.t === 'placeholder'){
      var pp5 = possibSimpl.prompt;
      if (!pp5){
        pp5 = '';
      }
      window.alert('[Placeholder] ' + pp5);
    }else if (possibSimpl.t === 'toggleBannerVisibility'){

      function toggleBannerVisibilityFn(){
        if (!itemsToCheck(['alert', 'visibility'], possibSimpl, doEvalG)){
          setTimeout(function(e){toggleBannerVisibilityFn()}, 500);
          return;
        }
        var vis = doEvalG(possibSimpl.visibility, {t:'Boolean'});
        var alertKey = doEvalG(possibSimpl.alert, {t:'Alert'});
        if (vis){
          delete alertVisibility[alertKey] 
        }else{
          alertVisibility[alertKey] = 1;          
        }
        setAlertVisibility(alertVisibility);
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
      }
      toggleBannerVisibilityFn();      
    }else if (possibSimpl.t === 'hideOwnBanner'){
      var firstParts = CoreFns.filterPathStopBefore(entityPathIn, 6).join('_');
      alertVisibility[firstParts] = 1;
      setAlertVisibility(alertVisibility);
      // console.log(firstParts);      
      // console.log(entityPathIn);

    }else if (possibSimpl.t === 'openPopUp'){

      function openPopUpFn(){

        if (!itemsToCheck(['popUp'], possibSimpl, doEvalG)){
          setTimeout(function(e){openPopUpFn()}, 500);
          return;
        }
        var popUp = doEvalG(possibSimpl.popUp, {t:'PopUp'});
        popUps.push({t:'normal', v:popUp});
        setPopUps([...popUps]);
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
      }
      openPopUpFn();

    }else if (possibSimpl.t === 'closePopUp'){

      popUps.pop();
      setPopUps([...popUps]);
      doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        

    // }else if (possibSimpl.t === 'writeToDatabase'){

    //   if (programSetID === -1){
    //     window.alert('This function is not activated in template selection mode');
    //     return;
    //   }
      
    //   function writeToDatabaseFn(){
    //     if (!itemsToCheck(['v'], possibSimpl, doEvalG)){
    //       setTimeout(function(e){writeToDatabaseFn()}, 500);
    //       return;
    //     }
    //     var toWrite = doEvalG(possibSimpl.v, {t:'Text String'});
    //     function postPost(){
    //       doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);        
    //     }
    //     ServerComms.fetchSomething({u:'writeToDatabase', toWrite, programSetID}, postPost);
    //   }
    //   writeToDatabaseFn();      
    }else if (possibSimpl.t === 'confirm'){

      function confirmFn(){
        if (!itemsToCheck(['msg'], possibSimpl, doEvalG)){
          setTimeout(function(e){confirmFn()}, 500);
          return;
        }
        var c = window.confirm(doEvalG(possibSimpl.msg, {t:'Text String'}));
        if (c){
          doSimplInteract(possibSimpl.If_Confirm, entityPathIn.concat(['If_Confirm']), upwardInfoHere, newDepth);
        }else{
          doSimplInteract(possibSimpl.If_Deny, entityPathIn.concat(['If_Deny']), upwardInfoHere, newDepth);
        }        
      }
      confirmFn();

    }else if (possibSimpl.t === 'ifThenElse'){

      function ifThenElseFn(){
        if (!itemsToCheck(['cond'], possibSimpl, doEvalG)){
          setTimeout(function(e){ifThenElseFn()}, 500);
          return;
        }
        var cond = doEvalG(possibSimpl.cond, {t:'Boolean'});
        if (cond){
          doSimplInteract(possibSimpl.If_True, entityPathIn.concat(['If_True']), upwardInfoHere, newDepth);
        }else{
          doSimplInteract(possibSimpl.If_False, entityPathIn.concat(['If_False']), upwardInfoHere, newDepth);
        }        
      }
      ifThenElseFn();
    }else if (possibSimpl.t === 'updateVar'){

      function updateVarFn(){
        if (!itemsToCheck(['newVal'], possibSimpl, doEvalG)){
          setTimeout(function(e){updateVarFn()}, 500);
          return;
        }

        if (possibSimpl.var.indexOf('ov_') === 0){
          var theOVKey = possibSimpl.var.substr(3);
          var thisOV = currentList.ov[theOVKey];
          if (thisOV){
            var aspect = possibSimpl.aspect;
            var startType = CoreFns.convertSelectionToType(thisOV.t, currentList);
            var pDown = [theOVKey];
            function iterateThroughTypeAndAspect(aspect, type){
              if (type.t === 'ListType'){
                if (aspect.i === 'item'){
                  pDown.push( doEvalG(aspect.subs.iNos, {t:'UInteger'}));
                  return iterateThroughTypeAndAspect(aspect.subs.aspect, type.c);
                }else{
                  return type;
                }
              }else{
                return type;
              }
            }

            var outType = iterateThroughTypeAndAspect(aspect, startType);

            var newValProc = doEvalG(possibSimpl.newVal, outType);

            var oV = ownVariables;
            for (var i6 = 0; i6 < pDown.length - 1; i6++){
              oV = oV[pDown[i6]];
            }
            oV[pDown[pDown.length - 1]] = newValProc;
            setOwnVariables({...ownVariables});
            doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);

          }
        }

      }
      updateVarFn();
   }else if (possibSimpl.t === 'listPush' || possibSimpl.t === 'listRemoveItem' || possibSimpl.t === 'listRemoveIndex'){

      function listPushFn(){
        if (possibSimpl.t === 'listPush' || possibSimpl.t === 'listRemoveItem'){
          if (!itemsToCheck(['newVal'], possibSimpl, doEvalG)){
            setTimeout(function(e){listPushFn()}, 500);
            return;
          }          
        }else if (possibSimpl.t === 'listRemoveIndex'){
          if (!itemsToCheck(['indexToRemove'], possibSimpl, doEvalG)){
            setTimeout(function(e){listPushFn()}, 500);
            return;
          }          
        }

        if (possibSimpl.var.indexOf('ov_') === 0){
          var theOVKey1 = possibSimpl.var.substr(3);
          var thisOV1 = currentList.ov[theOVKey1];
          if (thisOV1){
            // var aspect = possibSimpl.aspect;
            var startType1 = CoreFns.convertSelectionToType(thisOV1.t, currentList);
            var pDown1 = [theOVKey1];
            // function iterateThroughTypeAndAspect(aspect, type){
            //   if (type.t === 'ListType'){
            //     if (aspect.i === 'item'){
            //       pDown.push( doEvalG(aspect.subs.iNos, {t:'UInteger'}));
            //       return iterateThroughTypeAndAspect(aspect.subs.aspect, type.c);
            //     }else{
            //       return type;
            //     }
            //   }else{
            //     return type;
            //   }
            // }

            // var outType = iterateThroughTypeAndAspect(aspect, startType);
            var oV1 = ownVariables;
            for (var i61 = 0; i61 < pDown1.length - 1; i61++){
              oV1 = oV1[pDown1[i61]];
            }

            if (possibSimpl.t === 'listPush' || possibSimpl.t === 'listRemoveItem'){
              var newValProc1 = doEvalG(possibSimpl.newVal, startType1.c);
              if (possibSimpl.t === 'listPush'){
                oV1[pDown1[pDown1.length - 1]].push(newValProc1);
              }else if (possibSimpl.t === 'listRemoveItem'){
                var removeAll = doEvalG(possibSimpl.nosToRemove, {t:'Boolean'});
                var newList = [];
                var neverRemoveBefore = true;
                oV1[pDown1[pDown1.length - 1]].forEach((aV, index)=>{
                  var pp = FormulaFunctions.checkEquality(aV, newValProc1, startType1.c);
                  if (pp && neverRemoveBefore){
                    if (removeAll){
                    }else{
                      neverRemoveBefore = false;
                    }
                  }else{
                    newList.push(aV);
                  }
                })
                oV1[pDown1[pDown1.length - 1]] = newList;
              }
            }else if (possibSimpl.t === 'listRemoveIndex'){
              var indexToRemove = doEvalG(possibSimpl.indexToRemove, {t:'UInteger'});
              var startFromFront = doEvalG(possibSimpl.startPoint, {t:'Boolean'});
              var count = 0;
              if (startFromFront){
                count = Number(indexToRemove);
              }else{
                count = -(Number(indexToRemove) + 1);
              }
              oV1[pDown1[pDown1.length - 1]].splice(count, 1);
            }

            setOwnVariables({...ownVariables});
            doSimplInteract(possibSimpl.next, entityPathIn.concat(['next']), upwardInfoHere, newDepth);

          }
        }

      }
      listPushFn();

    }else if (possibSimpl.t.indexOf('changeInputValue') === 0){

      function changeInputValueFn(){

        var pp = possibSimpl.t.substr(16).split(' ');
        var item;
        try{
          item = CoreFns.goDownPath(currentList, pp);
          if (!item){
            return false;
          }
        }catch(err){
          return false;
        }
        var vS = ResponsiveFns.getDefaultTypeAndPointerFromItem(item);

        var newVal = doEvalG(possibSimpl[vS.i], vS.iT);
        if (vS.iT.t === 'UInteger' || vS.iT.t === 'Integer' || vS.iT.t === 'Decimal'){ 
          newVal = newVal.toString();
        }
        var itemSet3 = [];
        var pathWayConcats = itemSet3.map((anItem, index)=>{
          return anItem.k.i;
        });
        var pathWay = itemSet3.map((anItem, index)=>{
          var thisVal = doEvalG(possibSimpl[anItem.k.i], {t:'UInteger'}); //not used yet, i suspect the UInteger may be wrong.
          return CoreFns.convertToStrings(thisVal, anItem.t);
        }).join('_');
        if (!itemsToCheck([vS.i].concat(pathWayConcats), possibSimpl, doEvalG)){
          setTimeout(function(e){changeInputValueFn()}, 500);
          return;
        }
        var ppX = pp.join(' ')+'_'+pathWay;
        inputValues[ppX].value = newVal;
        setInputValues({...inputValues});
        doSimplInteract(possibSimpl.next, entityPathIn.concat(['Post_Change_Value']), upwardInfoHere, newDepth);        
      }
      changeInputValueFn();

    }else if (possibSimpl.t.indexOf('existingContractFn') === 0){
      if (internalVariables.activeUser){
        var isCorrectChain1 = StyleFunctions.isCorrectChain(currentList, internalVariables);
        if (isCorrectChain1){
          var parts = possibSimpl.t.split(' ');
          var contractInfoAbi = CoreFns.getContractInfoAbi(currentList, parts[1]);
          var address = ResponsiveFns.getContractAddr( currentList, parts[1]);
          var pointer = parts[2];
          var thisAbi = ResponsiveFns.existingContractRelevantAbi(parts[1], pointer, parts[3], currentList);


            function doFn(){

              var toAddCheck = [];
              var inputProcessed = thisAbi.inputs.map((anInput, index)=>{
                var type = TypeEvaluation.convertSCTypeToInternalType(anInput, currentList);
                return doEvalG(possibSimpl[anInput.name], type);
              })
              var ii = thisAbi.inputs.map((anInput, index)=>{
                return anInput.name;
              })
              var allOk = itemsToCheck(ii.concat(toAddCheck), possibSimpl, doEvalG);
              if (allOk){
                var stuff = {
                    address,
                    abi: contractInfoAbi,
                    args:inputProcessed,
                    functionName: pointer
                  };

                var b = {
                    onError(e){
                      if (possibSimpl.If_Fail && possibSimpl.If_Fail.t){
                       doSimplInteract(possibSimpl.If_Fail, entityPathIn.concat(['If_Fail']), upwardInfoHere.concat([{v:e, t:'If_Fail_'+depth}]), newDepth);
                      }else{
                        window.alert('[Default message as no If Fail Condition specified] ' + e)
                      }
                    },
                    onSuccess(data){

                      if (possibSimpl.trig && possibSimpl.trig.i && possibSimpl.If_Succeed && possibSimpl.If_Succeed.t){

                        var possibSimplTrigParts = possibSimpl.trig.i.split(' ');

                        var thisAbiNew;
                        for (var i5 = 0; i5 < contractInfoAbi.length; i5++){
                          if (contractInfoAbi[i5].name === possibSimplTrigParts[0] && contractInfoAbi[i5].inputs.length === +possibSimplTrigParts[1]){
                            thisAbiNew = contractInfoAbi[i5];
                            break;
                          }
                        }

                        var subs = possibSimpl.trig.subs;
                        var eventName = thisAbiNew.name;
                        var thisE = {
                          address,
                          abi: contractInfoAbi,
                          eventName,
                          onError(e){
                            console.log(e)
                          },
                          onLogs(log) {
                            
                            delete contractEvents[address + '_' + eventName];
                            setContractEvents({...contractEvents});
                            doSimplInteract(possibSimpl.If_Succeed, entityPathIn.concat(['If_Succeed']), upwardInfoHere, newDepth);
                          } 
                        }

                        var args = {};
                        var inputs = thisAbiNew.inputs;
                        inputs.forEach((anInput, index)=>{
                          if (anInput.indexed){
                            var thisSub = subs[anInput.name];
                            if (+thisSub.o === 1){
                              var thisValue = CoreFns.getFollowUp(thisSub);
                              var inputType = TypeEvaluation.convertSCTypeToInternalType(anInput);
                              var out = doEvalG(thisValue.v, inputType);
                              args[anInput.name] = out;
                            }
                          }
                        })

                        thisE.args = args;

                        contractEvents[address + '_' + eventName] = thisE;
                        setContractEvents({...contractEvents});
                      }

                    },
                    onSettled(data){
                    }
                };

                if (thisAbi.stateMutability === 'payable'){
                  toAddCheck = ['_0'];
                  var currencyDecimals = +StyleFunctions.numberOfDecimalsFromCurrentList(currentList, chains);
                  var xxx = doEvalG(possibSimpl['_0'], {t:'Decimal'});
                  var value = StyleFunctions.makeADecimalTextIntoBigNum(xxx.toString(), currencyDecimals);
                  stuff.value = value;
                  // inputProcessed.push({value});
                }

                  writeContract(stuff, b);


                  // .then((aResponse)=>{
                  //   console.log(aResponse);
                  //   // doSimplInteract(possibSimpl.If_Succeed, entityPathIn.concat(['If_Succeed']), upwardInfoHere, newDepth);

                  // }).catch((e)=>{

                  // }).finally(() => {
                  //   setTimeout(function(){setChainInfo({});},15000);
                  // })

              }

            }

            doFn();
        }else{
          if (possibSimpl.If_Fail && possibSimpl.If_Fail.t){
            doSimplInteract(possibSimpl.If_Fail, entityPathIn.concat(['If_Fail']), upwardInfoHere.concat([{v:'Incorrect Chain', t:'If_Fail_'+depth}]), newDepth);
          }else{
            window.alert('Incorrect Chain');
          }
        }
      }else{
        if (possibSimpl.If_Fail && possibSimpl.If_Fail.t){
          doSimplInteract(possibSimpl.If_Fail, entityPathIn.concat(['If_Fail']), upwardInfoHere.concat([{v:'Not Connected', t:'If_Fail_'+depth}]), newDepth);                  
        }else{
          window.alert('Wallet not connected');
        }
      }
    }else{
      console.warn(possibSimpl);
    }

  }


  function doInteraction(e, ocSet, aPossib, upwardInfo, entityPath){

    if (aPossib)
      var possibSimpl = ocSet[aPossib];
      if (possibSimpl){
        doSimplInteract(possibSimpl, entityPath, upwardInfo, 0);
        if (e){
          if (possibSimpl.passT){
          }else{
            e.stopPropagation();
          }
        }
      }
    }  

  return doInteraction;
}

